<template>
  <div>
    <div v-if="userInfoOrder" class="flex-between" style="width: 100%">
      <div style="width: 60%" class="margin-left-10">
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in tab"
            :key="item.state"
            :label="item.stateStr + ` (${item.nums})`"
            :value="item.state"
            :name="item.state"
          />
        </el-tabs>
      </div>
      <el-descriptions column="1" style="width: 30%">
        <el-descriptions-item label="订单消费金额"
          >{{ userInfoOrder.payAmount }}元（计算订单剩余金额）</el-descriptions-item
        >
      </el-descriptions>
    </div>
    <el-table
      :data="records"
      border
      size="mini"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <el-table-column label="订单编号" prop="orderNo" align="center" width="220">
        <template slot-scope="scope">
          <span style="cursor: pointer" class="color-mainColor" @click="handleDetails(scope.row)">{{
            scope.row.orderNo
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="线路" prop="lineName" align="center" />
      <el-table-column label="出发时间" prop="departureDateTime" align="center" />
      <el-table-column label="实际人数" prop="passengerNums" align="center" width="90" />
      <el-table-column label="支付金额(元)" prop="payAmount" align="center" />
      <el-table-column label="订单评价" prop="indicator" align="center">
        <template slot-scope="scope">
          {{ scope.row.indicator || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="stateStr" align="center" width="90" />
      <el-table-column label="开票状态" prop="invoiceStateStr" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.invoiceStateStr }}</span>
          <el-button
            v-if="scope.row.invoiceState === 1"
            type="text"
            @click="getUserInvoiceUrl(scope.row.id)"
            class="font-12 margin-left-10"
            >查看发票</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: right; margin-right: 20px; margin-top: 20px">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationObj.current"
        :page-size="paginationObj.size"
        background
        layout="prev, pager, next"
        :total="total"
        size="mini"
      />
    </div>
    <intercity-info ref="interCityInfo" v-if="showVisible" />
  </div>
</template>

<script>
  import { userInfoOrderPage, userInvoiceUrl } from '@/api'
  import intercityInfo from '@/views/order/intercity/intercity-info'
  export default {
    components: {
      intercityInfo
    },
    props: {
      order: {
        type: Object,
        default: () => {}
      },
      userInfoOrder: {
        type: Object,
        default: () => {}
      },
      userId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        records: [],
        total: 0,
        paginationObj: {
          current: 1,
          size: 5
        },
        loading: false,
        showVisible: false,
        active: '0',
        tab: []
      }
    },
    mounted() {
      this.records = this.order.records || []
      this.total = this.order.total || 0
      console.log('total', this.total)
      this.tab.push({
        nums: this.userInfoOrder.totalNums || 0,
        state: '0',
        stateStr: '全部'
      })
      this.tab.push(...this.userInfoOrder.orderCounts)
    },
    methods: {
      handleClick(tab) {
        if (tab.name !== '0') {
          this.state = tab.name
        } else {
          this.state = ''
        }
        this.paginationObj.current = 1
        this.getPage()
      },
      handleDetails(row) {
        this.showVisible = true
        this.$nextTick(() => {
          this.$refs.interCityInfo.init(row)
        })
      },
      async getUserInvoiceUrl(id) {
        this.$loading({})
        const { code, data } = await userInvoiceUrl(id)
        if (code === 0) {
          this.$loading().close()
          window.location.href = data
        }
      },
      async getPage() {
        this.loading = true
        const params = {
          ...this.paginationObj,
          userId: this.userId,
          state: this.state
        }
        const { code, data } = await userInfoOrderPage(params)
        if (code === 0) {
          const { total, records } = data
          this.records = records
          this.total = total
        }
        this.loading = false
      },
      handleCurrentChange(e) {
        this.paginationObj.current = e
        this.getPage()
      }
    }
  }
</script>

<style lang="scss" scoped></style>
